<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Create Redemption Code Set</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0">

    <div class="form-group">
      <label for="nameInput">Name</label>
      <input type="text" class="form-control"
             required
             id="nameInput" name="nameInput"
             [(ngModel)]="name">
      <small class="form-text text-muted">
        This name is for internal staff use only. It is not displayed to the customer.
      </small>
    </div>

    <div class="form-group">
      <label for="productType">Product Type</label>
      <select class="custom-select"
              [(ngModel)]="productType"
              (ngModelChange)="productId = null"
              id="productType" name="productType">
        <option [ngValue]="null"
                *ngIf="productType === null"
                disabled class="disabled">
          Select a Product Type
        </option>
        <option *ngFor="let productTypeOption of Object.values(RedemptionCodeSetProductType)"
                [ngValue]="productTypeOption">
          {{ getRedemptionCodeSetProductTypeDisplay(productTypeOption) }}
        </option>
      </select>
    </div>

    <div class="form-group indented-subsection"
         *ngIf="productType === RedemptionCodeSetProductType.membership">
      <label for="membership">Membership</label>
      <select class="custom-select"
              [(ngModel)]="productId"
              id="membership" name="membership">
        <option [ngValue]="null"
                *ngIf="productId === null"
                disabled class="disabled">
          Select a Membership
        </option>
        <option *ngFor="let membership of memberships"
                [ngValue]="membership.id">
          {{ membership.name }}
          <ng-container *ngIf="membership.status === MembershipStatus.draft">
            (Draft)
          </ng-container>
        </option>
      </select>
      <small class="form-text text-muted">
        Only prepaid individual memberships may be used with redemption codes.
      </small>
    </div>

    <div class="form-group indented-subsection"
         *ngIf="productType === RedemptionCodeSetProductType.entryPass">
      <label for="entryPass">Entry Pass</label>
      <select class="custom-select"
              [(ngModel)]="productId"
              id="entryPass" name="entryPass">
        <option [ngValue]="null"
                *ngIf="productId === null"
                disabled class="disabled">
          Select an Entry Pass
        </option>
        <option *ngFor="let entryPass of entryPasses"
                [ngValue]="entryPass.id">
          {{ entryPass.name }}
          <ng-container *ngIf="entryPass.status === EntryPassStatus.draft">
            (Draft)
          </ng-container>
        </option>
      </select>
    </div>

    <div class="form-group indented-subsection"
         *ngIf="productType === RedemptionCodeSetProductType.voucherPack">
      <label for="voucherPack">Voucher Pack</label>
      <select class="custom-select"
              [(ngModel)]="productId"
              id="voucherPack" name="voucherPack">
        <option [ngValue]="null"
                *ngIf="productId === null"
                disabled class="disabled">
          Select a Voucher Pack
        </option>
        <option *ngFor="let voucherPack of voucherPacks"
                [ngValue]="voucherPack.id">
          {{ voucherPack.name }}
          <ng-container *ngIf="voucherPack.status === VoucherPackStatus.draft">
            (Draft)
          </ng-container>
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="expirationDate">Expiration Date (optional)</label>
      <app-date-picker [id]="'expirationDate'"
                       [(content)]="expirationDate"></app-date-picker>
      <small class="form-text text-muted">
        The codes will expire at the end of the chosen date. Leave this blank in order to keep the codes available indefinitely.
      </small>
    </div>

    <div class="form-group">
      <label for="autogenerateCodes">How will the codes be generated?</label>
      <select class="custom-select"
              [(ngModel)]="autogenerateCodes"
              id="autogenerateCodes" name="autogenerateCodes">
        <option [ngValue]="true">Automatically by Capitan</option>
        <option [ngValue]="false">From a Provided List</option>
      </select>
    </div>

    <div class="form-group indented-subsection" *ngIf="autogenerateCodes">
      <label for="numCodes">Number of Codes</label>
      <input class="form-control"
             type="number" min="1" max="1000" step="1"
             [(ngModel)]="numCodes"
             name="numCodes" id="numCodes">
      <small class="form-text text-muted">
        The number of codes generated must be between 1 and 1000, inclusive.
      </small>
    </div>

    <div class="form-group indented-subsection" *ngIf="!autogenerateCodes">
      <label for="codeString">Codes</label>
      <textarea class="form-control"
                [(ngModel)]="codeString"
                (ngModelChange)="updateCodeList()"
                id="codeString" name="codeString"></textarea>
      <small class="form-text text-muted">
        Each code must be on a separate line, and may be no longer than 32 characters.
        <br>
        <b>{{ codeList.length }} code{{ codeList.length === 1 ? '' : 's' }} entered.</b>
      </small>
    </div>

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            *ngIf="!loadingSubmit"
            [disabled]="!submitAvailable()"
            [class.disabled]="!submitAvailable()"
            (click)="handleSubmit()">
      Create
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
